import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusBottomRight12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconRadiusBottomRight12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.115 10.07h3.24a3.5 3.5 0 0 0 3.5-3.5V3.206a.5.5 0 1 1 1 0V6.57a4.5 4.5 0 0 1-4.5 4.5h-3.24a.5.5 0 1 1 0-1m5.006-7.695a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m-3-.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-1.5.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M.943 6.074a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m.75 2.974a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m-.75-5.199a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusBottomRight12);
